import type { FC } from 'react';
import { lazy } from 'react';
import type { CapacityManagementRootRequest } from 'src/apis/capacity-management/use-capacity-management-root';
import { useCmNetworkPoint } from 'src/apis/capacity-management/use-cm-network-point';
import { usePriceSteps } from 'src/apis/capacity-management/use-price-steps';
import type { NetworkPointRequest } from 'src/apis/monolith/use-network-point';
import type { Successful } from 'src/hooks/use-axios';
import { useTitle } from 'src/hooks/use-title';

const Page = lazy(() => import('./page'));

type Props = {
  networkPoint: Successful<NetworkPointRequest>;
  capacityManagementRoot: Successful<CapacityManagementRootRequest>;
};

export const EditPriceSteps: FC<Props> = ({
  capacityManagementRoot,
  networkPoint,
}) => {
  const cmNetworkPoint = useCmNetworkPoint({
    capacityManagementRoot,
    networkPoint,
  });

  const priceSteps = usePriceSteps({ cmNetworkPoint });

  useTitle('Edit Price Steps');

  return <Page cmNetworkPoint={cmNetworkPoint} priceSteps={priceSteps} />;
};
